import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

export const Navigation = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const savedToken = localStorage.getItem("token");
    if (savedToken) {
      setToken(savedToken);
      setIsLoggedIn(true);
    }
  }, []);

  const handleDashboardClick = async () => {
    try {
      // 👉 popup dikhana
      Swal.fire({
  title: "Please select a plan first!",
  text: "You need to choose a pricing plan before accessing the dashboard.",
  icon: "info",
  confirmButtonText: "Go to Pricing",
  confirmButtonColor: "rgb(204, 102, 0)", // ✅ Button color
  iconColor: "rgb(204, 102, 0)", // ✅ Icon (i) color
  customClass: {
    popup: "custom-swal-popup",
  },
}).then((result) => {
        if (result.isConfirmed) {
          // pricing section pe scroll
          window.location.href = "/#pricing";
        }
      });
    } catch (err) {
      console.error("Dashboard Click Error:", err);
      alert("❌ Something went wrong");
    }
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <a className="navbar-brand page-scroll" href="#page-top">
            <img
              src="/img/logo.png"
              alt="Business Unbuzzed"
              style={{ height: "50px", width: "auto" }}
            />
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li><a href="/#header" className="page-scroll">Home</a></li>
            <li><a href="/#about" className="page-scroll">Problems</a></li>
            <li><a href="/#solution" className="page-scroll">Solution</a></li>
            <li><a href="/#technology" className="page-scroll">Technology</a></li>
            <li><a href="/#lead-magnet" className="page-scroll">Free Assessment</a></li>
            <li><a href="/#pricing" className="page-scroll">Pricing</a></li>
            <li><a href="/#transparent-section" className="page-scroll">Contact</a></li>

            {isLoggedIn ? (
              <li>
                <button
                  onClick={handleDashboardClick}
                  className="btn btn-custom-login btn-lg"
                  style={{
                    padding: "10px 15px",
                    borderRadius: "6px",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  Dashboard
                </button>
              </li>
            ) : (
              <li>
                <a
                  href="/login"
                  className="btn btn-custom-login btn-lg"
                  style={{
                    padding: "10px 15px",
                    borderRadius: "6px",
                    color: "#fff",
                  }}
                >
                  Login
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};
const style = document.createElement("style");
style.innerHTML = `
  .custom-swal-popup .swal2-icon.swal2-info {
    border-color: rgb(204, 102, 0) !important;
    color: rgb(204, 102, 0) !important;
  }
  .custom-swal-popup .swal2-icon.swal2-info::before {
    background-color: rgb(204, 102, 0) !important; 
  }
`;
document.head.appendChild(style);

export default Navigation;
